<template>
    <article class="ArticleTextAndImage" v-if="ready">
        <div class="ArticleTextAndImage__text">
            <h3>{{ this.properties.title }}</h3>
            <span v-html="this.properties.text"></span>
        </div>
        <div class="ArticleTextAndImage__image"><img :src="getMediaPath(this.properties.image.src)" /></div>
    </article>
</template>


<script>
export default {
    props: ["properties"],
    data() {
        return {
            ready: false,
        }
    },
    mounted() {
        console.log(this.properties);
        this.ready = true;

    },
    methods: {

        closeComponent() {
            this.$emit("closeComponent", this.slug)
        },
        getMediaPath(mediaUrl) {
            return app.api.Utils.getMediaPath(mediaUrl)
        },

    },
    computed: {

    }
};

</script>


<style lang="scss">
.ArticleTextAndImage {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 55px 55px;
    display: flex;
    justify-content: space-between;


    &__text {
        width: 750px;
        overflow: auto;
        text-align: left;
        padding-right: 20px;

        span {
            line-height: 1.3em;
        }
    }

    &__image {
        width: 940px;
        height: 100%;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 20px;
        }
    }


}
</style>
